import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight, Clock, BookOpen } from "lucide-react";
import { api } from "../lib/api";
import PageHero from "../components/PageHero";
import SEO from "../components/SEO";

export default function Blog() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api
      .get("/blog")
      .then((r) => setPosts(r.data))
      .catch(() => setPosts([]))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div data-testid="blog-page">
      <SEO
        title="Rehber - Teknik Yazılar"
        description="Fardriver kontrolör seçimi, FOC sinüs sürüş, scooter hızlandırma, Bluetooth tuning. Elektrikli motor kontrolör teknik rehberleri."
        path="/rehber"
      />

      <PageHero
        overline="Rehber"
        title="Elektrikli motor kontrolörleri için Türkçe teknik rehberler."
        description="Doğru kontrolör seçiminden gelişmiş tuning'e, FOC teknolojisinden scooter performansına kadar bilmeniz gereken her şey."
      />

      <section className="max-w-5xl mx-auto px-6 py-16 md:py-20">
        {loading ? (
          <div className="text-center text-gray-500 py-20">Yazılar yükleniyor...</div>
        ) : posts.length === 0 ? (
          <div className="text-center text-gray-500 py-20">Henüz yazı eklenmemiş.</div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {posts.map((post, i) => (
              <motion.article
                key={post.slug}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: i * 0.05 }}
                data-testid={`blog-card-${post.slug}`}
                className="group border border-gray-200 bg-white hover:border-[#059669] transition-all"
              >
                <Link to={`/rehber/${post.slug}`} className="block p-7 h-full">
                  <div className="flex items-center gap-3 mb-4 text-xs uppercase tracking-[0.2em] font-mono-fd">
                    <span className="text-[#059669] font-semibold">{post.category}</span>
                    <span className="text-gray-400">·</span>
                    <span className="text-gray-500 inline-flex items-center gap-1.5">
                      <Clock size={12} /> {post.reading_time} dk
                    </span>
                  </div>
                  <h2 className="font-display text-xl md:text-2xl tracking-tight font-bold leading-tight group-hover:text-[#059669] transition-colors">
                    {post.title}
                  </h2>
                  <p className="mt-4 text-sm text-gray-600 leading-relaxed line-clamp-3">
                    {post.excerpt}
                  </p>
                  <div className="mt-6 inline-flex items-center gap-1.5 text-xs font-semibold uppercase tracking-[0.15em] text-[#059669] border-b-2 border-[#059669]">
                    Devamını oku <ArrowRight size={12} />
                  </div>
                </Link>
              </motion.article>
            ))}
          </div>
        )}
      </section>

      <section className="border-t border-gray-200 bg-gray-50">
        <div className="max-w-4xl mx-auto px-6 py-16 md:py-20 text-center">
          <BookOpen className="mx-auto text-[#059669] mb-5" size={32} />
          <h2 className="font-display text-2xl md:text-3xl tracking-tighter font-black">
            Aradığınız konu yok mu?
          </h2>
          <p className="mt-4 text-gray-600 max-w-xl mx-auto leading-relaxed">
            Aracınız veya kontrolör projeniz hakkında özel sorularınızı WhatsApp üzerinden bize iletin,
            Türkçe teknik destek ile uzaktan yönlendirme sağlıyoruz.
          </p>
          <Link
            to="/iletisim"
            data-testid="blog-contact-cta"
            className="mt-7 inline-flex items-center gap-2 bg-[#059669] text-white px-6 py-3 text-sm font-semibold uppercase tracking-[0.15em] hover:bg-emerald-700 transition-colors"
          >
            İletişime Geç <ArrowRight size={14} />
          </Link>
        </div>
      </section>
    </div>
  );
}
